// Pure helpers for the company list's "No service profile" marker, filter and worklist CSV.
// No imports, so `node --test tests/*.test.mjs` can load this file without a bundler.

// Live = the company page's own status meaning: `active` and `trial` are live;
// `inactive`, `pending` and `rejected` are not.
// Note: this is NOT the `routed OR billed_12m` rule behind the PM's 1,323 figure —
// the /company API carries no billing date, so that rule cannot be computed here.
export const LIVE_STATUSES = ['active', 'trial'];

export const WORKLIST_COLUMNS = ['id', 'status', 'cost_by', 'expect_trash'];

// True when expect_trash is null, undefined, blank or zero (0, '0', '0.00').
export function hasNoServiceProfile(company) {
  const value = company ? company.expect_trash : undefined;
  if (value === null || value === undefined) return true;
  if (typeof value === 'string' && value.trim() === '') return true;
  const number = Number(value);
  return Number.isNaN(number) || number <= 0;
}

export function isLive(company) {
  return !!company && LIVE_STATUSES.includes(company.status);
}

export function isWorklistCompany(company) {
  return isLive(company) && hasNoServiceProfile(company);
}

function csvCell(value) {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

// CSV of the live no-profile companies, exactly WORKLIST_COLUMNS — no name or personal field.
export function toWorklistCsv(companies) {
  const rows = (companies || []).filter(isWorklistCompany)
    .map((company) => WORKLIST_COLUMNS.map((column) => csvCell(company[column])).join(','));
  return `${[WORKLIST_COLUMNS.join(','), ...rows].join('\r\n')}\r\n`;
}
